import React from "react";
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    // console.error("[ErrorBoundary]", error);
    return { error };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    // logErrorToMyService(error, errorInfo);
    console.error("[ErrorBoundary]", error, errorInfo);
  }

  render() {
    if (this.state.error) {
      // You can render any custom fallback UI
      return (
        <Container>
          <br />
          <br />
          <Typography variant="h4">Oops! something went wrong :(</Typography>
          <br />
          {this.state.error.name === "ScriptExternalLoadError" &&
            <Typography variant="h6">Error loading external module</Typography>
          }
        </Container>)
    }

    return this.props.children;
  }
}

export default ErrorBoundary;